module.exports = __webpack_public_path__ + "img/symbol_13.65a40fb1.png";